<template>
    <div class="row">
        <div class="col-md-12 card-wrapper">
            <div class="card" style="min-height:500px;" v-if="showAccountList">
                <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">Kayıtlı Hesaplar</div>
                <div class="card-body bg-light color-gray">
                    <button class="btn bg-new-primary btn-lg" @click="addNewAccount">Yeni Hesap Ekle</button>
                    <div class="mt-4 agent-list">
                        <div class="mt-2" v-for="(agent,index) in sipAgents" v-bind:key="index">
                            <div class="d-flex justify-content-between align-items-center agent-card" style="background:#EDF8EF;" v-if="agent.status==='online' || agent.status==='busy'">
                                <div>
                                    <span class="fs-16">{{agent.name}}</span>
                                    <span class="agent-online ml-2">Aktif</span>
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="signout-btn" @click="connectSip('offline',agent.id)">
                                        <span class="material-icons mr-2" style="font-size:16px;">phone_disabled</span>
                                        <span>Çıkış Yap</span>
                                    </span> 
                                    <div class="ml-4 cursor" @click="updateAgent(agent.id)"><i class="fas fa-pen" style="color:#53565E;"></i></div>
                                    <div class="ml-4 cursor" @click="deleteAgent(agent.id)"><i class="fas fa-trash" style="color:#FF0000;"></i></div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center agent-card" v-else>
                                <div>
                                    
                                    <span class="fs-16">{{agent.name}}</span>
                                    <span class="agent-offline ml-3">Pasif</span>
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="signin-btn" @click="connectSip('online',agent.id)">
                                        <span class="material-icons mr-2" style="font-size:16px;">call</span>
                                        <span>Giriş Yap</span>
                                    </span> 
                                    <div class="ml-4 cursor" @click="updateAgent(agent.id)"><i class="fas fa-pen" style="color:#53565E;"></i></div>
                                    <div class="ml-4 cursor" @click="deleteAgent(agent.id)"><i class="fas fa-trash" style="color:#FF0000;"></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="card" v-else>
                <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">Yeni Hesap Ekle</div>
                <div class="card-body bg-light color-gray">
                    <div class="row">
                        <div class="col-md-6">
                            <div>
                                <label class="new-label">{{$ml.get('NAME')}} {{$ml.get('SURNAME')}}</label>
                                <input type="text" v-model="name" placeholder=" Örn. John Doe" class="new-input" />
                            </div>
                            <div>
                                <label class="new-label">Özel Kimlik*</label>
                                <input type="number" v-model="privateIdentity" placeholder=" +3360000000000" class="new-input" />
                            </div>
                            <div>
                                <label class="new-label">Public Identity*</label>
                                <input type="text" v-model="publicIdentity" placeholder="  sip: +3360000000000@mincrm.com" class="new-input" />
                            </div>
                            <div>
                                <label class="new-label">Password</label>
                                <input type="password" v-model="password" class="new-input" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div>
                                <label class="new-label">Realm*</label>
                                <input type="text" v-model="realm" placeholder="mincrm.com" class="new-input" />
                            </div>
                            <div>
                                <label class="new-label">WebSocket Server URL</label>
                                <input type="text" v-model="wsUrl" placeholder="ws://localhost:3000" class="new-input" />
                            </div>
                            <div>
                                <label class="new-label">SIP outbund Proxy URL</label>
                                <input type="text" v-model="sipOutboundUrl" placeholder="udp://pbx.hermesiletisim.net:5060" class="new-input" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer crm-modal-footer text-right bg-light">
                    <button class="btn " @click="resetForm()">{{$ml.get('CANCEL')}}</button>
                    <button class="btn bg-new-primary w-150p " @click="upsertSipSettingsF()">{{$ml.get('SAVE')}}</button>
                </div>
            </div>
        </div>
        <!-- Delete Agent Modal -->
        <div class="modal fade h-100" id="deleteAgentSetting" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content px-2 py-3 bg-white">
                    <div class="modal-body text-center">
                        <i class="far fa-trash-alt fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                        <h2 class="my-3" style="color:#47495A;">Ayarı Sil</h2>
                        <p style="color: #53565E; font-size: 16px;">
                            Ayar silinecek. Onaylıyor musunuz?
                        </p>
                    </div>
                    <div class="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" @click="confirmFilterDeletion">{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>

<script>
import { mapState,mapGetters,mapActions } from 'vuex'
import axios from 'axios'

export default {
    name:'callCenterSettings',
    data() {
        return {
            showAccountList:true,
            sipAgents:[],
            sipSettings:[],
            sipSettingsId:'',
            name:'',
            realm:'',
            privateIdentity:'',
            publicIdentity:'',
            wsUrl:'',
            sipOutboundUrl:'',
            password:'',
            actionType:'',
            isDeleted:'',
            intervalItem: null,
            sipStatusObj:{},
            deleteAgentId:""
        }
    },
    computed: {
        ...mapState(['baseUrl',]),
        ...mapGetters(['user_settings','sipSettingsObj'])
    },
    methods: {
        addNewAccount(){
            this.showAccountList=false
        },
        resetForm(){
            this.showAccountList=true
            this.name = ""
            this.realm = ""
            this.privateIdentity = ""
            this.publicIdentity = ""
            this.sipOutboundUrl = ""
            this.wsUrl = ""
            this.password = ""
            this.sipSettingsId = ""
        },
        getSipSettingsF(){
            axios({
                method:'POST',
                url:'/getSipSettings',
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    this.sipSettings = res.data.content.settings.reverse()
                    this.getAgents()
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        upsertSipSettingsF(type){
            var params = {}
            if(this.sipSettingsId !== ""){
                params.sipSettingsId=this.sipSettingsId
            }
            if(type !==undefined && type === 'isDeleted'){
                params.isDeleted=true
            }
            params.name = this.name
            params.realm = this.realm
            params.privateIdentity = this.privateIdentity
            params.publicIdentity = this.publicIdentity
            params.wsUrl = this.wsUrl
            params.sipOutboundUrl = this.sipOutboundUrl
            params.password = this.password

            axios({
                method:'POST',
                url:'/upsertSipSettings',
                baseURL: this.baseUrl,
                data:params,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    this.getSipSettingsF()
                    this.getAgents()
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESS'),
                        text: res.data.status.desc 
                    })
                    this.resetForm()
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        getAgents(){
            axios({
                method:'POST',
                url:'/getCompanySipAgentsWithStatus',
                baseURL: this.baseUrl,
                data:{
                    blockLoadingBar:true
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data){
                    this.sipAgents = []
                    for(let agent of this.sipSettings){
                        for(let item of res.data){
                            if(agent._id.$oid === item.id){
                                this.sipAgents.push(item)
                            }
                        }
                    }
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        refreshAgentsAfterSipStatus(event){
            if(!event || !event.detail || !event.detail.status){
                this.getAgents()
            }
        },
        updateAgent(id){
            for(let item of this.sipSettings){
                if(item._id.$oid === id){
                    this.showAccountList=false
                    this.name = item.name
                    this.realm = item.realm
                    this.privateIdentity = item.privateIdentity
                    this.publicIdentity = item.publicIdentity
                    this.sipOutboundUrl = item.sipOutboundUrl
                    this.wsUrl = item.wsUrl
                    this.password = item.password
                    this.sipSettingsId = item._id.$oid
                }
            }
        },
        deleteAgent(id){
            $('#deleteAgentSetting').modal("show");
            this.deleteAgentId = id
        },
        confirmFilterDeletion(){
            for(let item of this.sipSettings){
                if(item._id.$oid === this.deleteAgentId){
                    this.sipSettingsId = item._id.$oid
                    this.upsertSipSettingsF('isDeleted')
                }
            }
        },
        getAgentHistoriesF(){
            var params = {}
            if(this.sipSettingsId !== ''){
                params.sipSettingsId = this.sipSettingsId
            }

            axios({
                method:'POST',
                url:'/getAgentHistories',
                baseURL: this.baseUrl,
                data: params,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        connectSip(status, id){
            let data = {}
            let checkStatus = false
            if(status === 'online'){
                for(let agent of this.sipAgents){
                    if(agent.status === 'online' ){
                        alert('Şuanda başka bir ayara bağlısınız.')
                        checkStatus = true
                        break
                    }
                }
                if(checkStatus==false){
                    for(let item of this.sipSettings){
                        if(id === item._id.$oid){
                            data.id = id
                            data.name = item.name
                            data.password = item.password
                            data.privateIdentity = item.privateIdentity
                            data.publicIdentity = item.publicIdentity
                            data.realm = item.realm
                            data.sipOutboundUrl = item.sipOutboundUrl
                            data.wsUrl = item.wsUrl
                            data.status  = status
                        }  
                    }
                    const sipClient = this.$root.$refs.sip
                    if (sipClient) {
                        sipClient.connect(data)
                    } else {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: this.$ml.get('ERROR'),
                            text: 'Telefon istemcisi henüz hazır değil. Lütfen tekrar deneyin.'
                        })
                    }
                }
            }

            if(status === 'offline'){
                const sipClient = this.$root.$refs.sip
                if (sipClient) {
                    sipClient.disconnect()
                }
            }
                  
        },
    },
    created() {
        this.$root.$refs.callCenterSettings = this
    },
    mounted() {
        window.addEventListener('sip-agent-status-changed', this.refreshAgentsAfterSipStatus)
        this.getSipSettingsF()
        // this.getAgents()
    },
    beforeUnmount() {
        window.removeEventListener('sip-agent-status-changed', this.refreshAgentsAfterSipStatus)
    },
}
</script>

<style scoped>
    .agent-card{
        border: 1px solid #D8D6D6;
        padding: 1.2rem 1rem;
        border-radius: 4px;
    }
    .fs-16 {
        font-size: 16px;
        color: #53565E;
        line-height: 21px;
        font-weight: 500;
    }
    .agent-online {
        background: #00D41D;
        padding: 0.2rem 1rem;
        color: white;
        border-radius: 4px;
    }
    .agent-offline {
        background: #53565E;
        padding: 0.2rem 1.5rem;
        color: white;
        border-radius: 4px;
    }
    .signin-btn {
        border: 1px solid #53565E ;
        border-radius: 4px;
        padding: 0.5rem .7rem;
        color: #53565E;
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .signout-btn {
        background: #53565E;
        border-radius: 4px;
        padding: 0.5rem .7rem;
        color: #ffffff;
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .cursor {
        cursor: pointer;
    }
</style>
